import React from 'react';
import { Box, Alert, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * AlertsShowcase Component
 * Displays alert variants with theme styling
 */
const AlertsShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12 }}>
      <Typography variant="subtitle2" gutterBottom>
        Alerts & Status Messages
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Alert
          severity="success"
          sx={{
            backgroundColor: `${theme.success_color || '#4caf50'}20`,
            color: theme.text_color,
            '& .MuiAlert-icon': { color: theme.success_color || '#4caf50' },
          }}
        >
          Success: Operation completed successfully
        </Alert>
        <Alert
          severity="error"
          sx={{
            backgroundColor: `${theme.error_color || '#f44336'}20`,
            color: theme.text_color,
            '& .MuiAlert-icon': { color: theme.error_color || '#f44336' },
          }}
        >
          Error: Something went wrong
        </Alert>
        <Alert
          severity="warning"
          sx={{
            backgroundColor: `${theme.warning_color || '#ff9800'}20`,
            color: theme.text_color,
            '& .MuiAlert-icon': { color: theme.warning_color || '#ff9800' },
          }}
        >
          Warning: Please review this action
        </Alert>
        <Alert
          severity="info"
          sx={{
            backgroundColor: `${theme.info_color || '#2196f3'}20`,
            color: theme.text_color,
            '& .MuiAlert-icon': { color: theme.info_color || '#2196f3' },
          }}
        >
          Info: Additional information available
        </Alert>
      </Box>
    </Grid>
  );
};

AlertsShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default AlertsShowcase;
